export const getTranslations = t => {
  return {
    searchCategoryTitle: t("kf.visualsearch.page.searchImage"),
    searchByImageTitle: t("kf.Globalvisualsearch.searchByImageTitle.text"),
    selectProductTitle: t("kf.Globalvisualsearch.selectProductTitle.text"),
    selectTypeTitle: t("kf.Globalvisualsearch.selectTypeTitle.text"),
    photoUploadTitle: t("kf.Globalvisualsearch.photoUploadTitle.text"),
    dragAndDrop: t("kf.visualsearch.ImageUpload.text"),
    dropFilesHere: t("kf.Globalvisualsearch.dropFilesHere.text"),
    orText: t("kf.contactus.label.orText"),
    uploadAFileButton: t("kf.contactus.label.uploadAFileButton"),
    QRCodeText: t("kf.visualsearch.QRCode.text"),
    uploadFileTypes: t("kf.Globalvisualsearch.label.uploadFileTypes"),
    uploadFileExtn: t("kf.Globalvisualsearch.label.uploadFileExtn"),
    uploadSizeLimit: t("kf.Globalvisualsearch.label.uploadSizeLimit"),
    uploadMBLimit: t("kf.Globalvisualsearch.label.uploadMBLimit"),
    dontSeeProduct: t("kf.Globalvisualsearch.dontSeeProduct.text"),
    getHelp: t("kf.Globalvisualsearch.getHelp.link"),
    imageUploadFileExtError: t(
      "kf.Globalvisualsearch.ImageUploadFileExtError.text"
    ),
    imageUploadFileSizeError: size =>
      t("kf.Globalvisualsearch.ImageUploadFileSizeError.text", { size }),
    findCategory: category =>
      t("kf.visualsearch.ImageUpload.title.findCategory", { category }),
    faucets: t("kf.product.category.faucets"),
    toilet: t("kf.product.category.toilets"),
    haveTrouble: t("kf.global.haveTrouble.text"),
    shower: t("kf.product.category.showers"),
    valve: t("kf.product.category.valves"),
    serviceParts: t("kf.product.category.serviceParts"),
    faucetParts: t("kf.product.subCategory.faucetParts"),
    toiletParts: t("kf.product.subCategory.toiletParts"),
    otherParts: t("kf.product.subCategory.otherParts"),
    newSearchTitle: t("kf.visualsearch.cameraGuide.newSearch"),
    photoSelectLibrary: t("kf.visualsearch.cameraGuide.photoSelectLibrary"),
    gotIt: t("kf.visualsearch.cameraGuide.gotIt"),
    baths: t("kf.product.category.baths"),
    showerDoors: t("kf.product.category.showerDoors"),
    sinks: t("kf.product.category.sinks"),
    textCommingSoon: t("kf.visualsearch.label.textCommingSoon"),
    searchImageText: t("kf.visualsearch.page.searchImage"),
    results: t("kf.plp.label.results"),
    home: t("kf.global.label.home"),
    searchResults: t("kf.technical.label.searchResults"),
    colorFinish: t("kf.pdp.label.colorOrFinish"),
    tooltip: t("kf.visualsearch.ImageCropper.toolTip"),
    toolTipCrop: t("kf.visualsearch.ImageCropper.toolTipCrop"),
    incorrectMatch: t("kf.visualsearch.label.textIncorrectMatch"),
    newSearch: t("kf.visualsearch.label.textNewSearch"),
    helpText: t("kf.visualsearch.label.textHelp"),
    feedbackText: t("kf.visualsearch.label.feedbackText"),
    closestMatch: t("kf.visualsearch.label.textClosestMatch"),
    partDiagramtext: t("kf.pdp.label.partsDiagram"),
    friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
    associatePrice: t("kf.pdp.label.associatePrice"),
    listPriceInfo: t("kf.pdp.label.listPriceInfo"),
    searchText: t("kf.visualsearch.page.search"),
    viewProduct: t("kf.visualsearch.page.viewProduct"),
    incorrectMatchText: t("kf.visualsearch.page.incorrectMatch"),
    errorText: t("kf.visualsearch.ErrorPage.errorText"),
    errorSubText: t("kf.visualsearch.ErrorPage.errorSubText"),
    tryAgainBtn: t("kf.visualsearch.ErrorPage.button.tryAgainBtn"),
    recognitionCategory: category =>
      t("kf.visualsearch.label.recognitionCategory", { category }),
    recognitionCategorySubText: category =>
      t("kf.visualsearch.label.recognitionCategorySubText", { category }),
    commingSoon: t("kf.visualsearch.label.commingSoon"),
    viewGuidtext: t("kf.visualsearch.button.viewGuid"),
    contactUs: t("kf.contactus.label.contactUsDisplayName"),
    incorrectMatchTxt: t("kf.globalvisualsearch.label.incorrectMatch"),
    incorrectMatchTryTxt: t("kf.globalvisualsearch.label.incorrectMatchTry"),
    incorrectTitle: t("kf.globalvisualsearch.label.incorrectTitle"),
    listPrice: t("kf.list.table.listPrice"),
    pageExpire: t("kf.globalvisualsearch.label.pageExpire"),
    txtSearch: t("kf.visualsearch.result.search"),
  }
}
